<template>
  <div id="default-select"
        class="tariff_block"
        :class="{'tariff_block__margin-top_disable': !showSelectTutor}"
  >
    <div class="tariff_elem block__desktop">
      <div class="tariff_item"
           :class="(activeTariff === item.id)?('tariff_item__active'):('')"
           v-for="(item, i) in tariffList"
           :key="'tariff_list_' + item.id"
           @click="choiceTariff(item.id, i)"
      >
        <div class="block block__row">
          <div class="item_svg"
               v-html="item.svg"
          ></div>

          <div class="block block__column">
            <div class="item_benefit"
                 v-if="item[activeTypeTutor].benefitText && (promoCodeApplied || benefitApplied) && (item[activeTypeTutor].oldCost > item[activeTypeTutor].cost)"
            >
              <span>{{ 'Скидка ' + item[activeTypeTutor].benefitText + ' ₽' }}</span>

              <BlockInfoCredit
                v-if="item[activeTypeTutor].isAccessCredit"
              ></BlockInfoCredit>
            </div>

            <div class="item_benefit"
                 v-else-if="item[activeTypeTutor].benefitText"
            >
              <span>{{ 'Выгода ' + item[activeTypeTutor].benefitText + ' ₽' }}</span>

              <BlockInfoCredit
                v-if="item[activeTypeTutor].isAccessCredit"
              ></BlockInfoCredit>
            </div>

            <div class="item_benefit item_benefit__text_default"
                 v-else-if="item[activeTypeTutor].isAccessCredit"
            >
              <span>{{ 'Доступна рассрочка' }}</span>
            </div>
            <div class="item_title">
              {{ item.title }}
            </div>
          </div>
        </div>

        <div class="block block__row">
          <div class="cost_block">
            <div class="old_cost"
                 v-if="(promoCodeApplied || benefitApplied) && (item[activeTypeTutor].oldCost > item[activeTypeTutor].cost)"
            >
              {{ item[activeTypeTutor].oldCostText + ' ₽' }}
              <div class="cost_dash"></div>
            </div>
            <div class="item_cost">
              {{ item[activeTypeTutor].costText + ' ₽' }}
            </div>
          </div>

          <div class="item_check">
            <div class="item_checked"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="tariff_elem block__mobile">
      <swiper class="swiper"
              :slidesPerView="'auto'"
              :spaceBetween="12"
              :pagination="false"
      >
        <swiper-slide class="tariff_slide"
                      v-for="(item, i) in tariffList"
                      :key="'tariff_list_' + i"
        >
          <div class="tariff_item"
               :class="(activeTariff === item.id)?('tariff_item__active'):('')"
               @click="choiceTariff(item.id, i)"
          >
            <div class="block block__row">
              <div class="item_svg"
                   v-html="item.svg"
              ></div>

              <div class="block block__column">
                <div class="item_benefit"
                     v-if="item[activeTypeTutor].benefitText && (promoCodeApplied || benefitApplied) && (item[activeTypeTutor].oldCost > item[activeTypeTutor].cost)"
                >
                  <span>{{ 'Скидка ' + item[activeTypeTutor].benefitText + ' ₽' }}</span>
                </div>

                <div class="item_benefit"
                     v-else-if="item[activeTypeTutor].benefitText"
                >
                  <span>{{ 'Выгода ' + item[activeTypeTutor].benefitText + ' ₽' }}</span>
                </div>

                <div class="item_benefit item_benefit__text_default"
                     v-else-if="item[activeTypeTutor].isAccessCredit"
                >
                  <span>{{ 'Есть рассрочка' }}</span>
                </div>
                <div class="item_title">
                  {{ item.title }}
                </div>
              </div>
            </div>

            <div class="block block__row">
              <div class="item_cost">
                {{ item[activeTypeTutor].costText + ' ₽' }}
              </div>

              <div class="item_check">
                <div class="item_checked"></div>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="tariff_border"></div>

    <div class="tariff_elem tariff_list">
      <!-- Список преимуществ тарифов -->
      <div class="special_aspect"
           v-for="(item) in getListSpecialAspects"
           :key="'tariff_special_aspect_' + item.idPoint"
      >
        <div class="aspect_image"
             :class="(item.isEnabled)?('aspect_image__green'):('aspect_image__gray')"
        >
          <transition name="fade" mode="out-in">
            <div class="aspect_svg"
                 :key="'svg_first_' + item.idPoint"
                 v-if="item.isEnabled"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.16688 11.8937L5.51553 9.24232L5.42272 9.14951L5.32991 9.24232L4.15158 10.4206L4.05877 10.5135L4.15158 10.6063L8.07408 14.5288L8.16688 14.6216L8.25969 14.5288L16.3489 6.4396L16.4417 6.34679L16.3489 6.25398L15.1705 5.07565L15.0777 4.98284L14.9849 5.07565L8.16688 11.8937Z"
                  fill="#89CE54" stroke="#89CE54" stroke-width="0.2625"/>
              </svg>
            </div>

            <div class="aspect_svg"
                 :key="'svg_second_' + item.idPoint"
                 v-else
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.4933 5.99369L13.9645 6.46495L10.7831 9.6464L10.4295 9.99995L10.7831 10.3535L13.9645 13.535L13.4933 14.0062L10.311 10.8247L9.95743 10.4712L9.60392 10.8247L6.42247 14.0062L5.95125 13.535L9.13269 10.3535L9.48625 9.99995L9.13269 9.6464L5.95125 6.46495L6.42247 5.99373L9.60392 9.17517L9.95743 9.52869L10.311 9.17522L13.4933 5.99369Z"
                  fill="#ABABB2" stroke="#ABABB2"/>
              </svg>
            </div>
          </transition>
        </div>

        <div class="aspect_text"
             :class="(item.isEnabled)?('aspect_text__black'):('aspect_text__gray')"
             v-html="item.text"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockInfoCredit from "../../../../DefaultBlock/BlockInfoCredit";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

export default {
  name: "DefaultSelect",

  props: {
    activeTariff: { // id активного тарифного плана
      type: Number,
      default: () => {
        return undefined
      }
    },

    tariffList: { // список тарифов
      type: Array,
      default: () => {
        return []
      }
    },

    activeTypeTutor: { // активный тип репетиторов
      type: String,
      default: () => {
        return 'topTutor'
      }
    },

    promoCodeApplied: { // применен промокод?
      type: Boolean,
      default: () => {
        return false
      }
    },

    benefitApplied: { // применена скидка при покупке 2-го предмета?
      type: Boolean,
      default: () => {
        return false
      }
    },

    showSelectTutor: { // отобразить выбор репетитора
      type: Boolean,
      default: () => {
        return false
      }
    },
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 12,
        pagination: {
          clickable: true
        }
      },
    }
  },

  created() {

  },

  mounted() {

  },

  methods: {
    /** Выбрать тариф
     * @param {Number} id - id тарифа
     * @param {Number} index - index элемента тарифа
    * */
    choiceTariff(id, index) {
      this.$emit('selectTariff', id, index);
    },

    /** Применить промокод
    * */
    applyPromoCode() {
      this.$emit('applyPromo');
    },

    /** Удалить промокод
    * */
    removePromoCode() {
      this.$emit('removePromo');
    },
  },

  computed: {

    /** Получить список преимуществ для активного пакета
     * @returns {Array}
    * */
    getListSpecialAspects() {
      let activeTariff = this.tariffList.find(item => this.activeTariff === item.id);
      if (!activeTariff) return [];
      return activeTariff.tariffSpecialAspects;
    },
  },

  components: {
    BlockInfoCredit,
    Swiper,
    SwiperSlide,
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../style/variables";

#default-select.tariff_block__margin-top_disable {
  margin-top: 0;
}

#default-select {
  .block__desktop {
    display: flex;
  }

  .block__mobile {
    display: none;
  }

  .block_promocode__mobile {
    display: none;
  }

  .block_promocode__tablet {
    display: none;
  }
}

.block_promo {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: flex-start;
  grid-gap: 12px;
  margin: 20px 24px;
}

.block__column {
  display: flex;
  flex-direction: column;
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tariff_block {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  grid-gap: 24px;
  margin-top: 32px;
  width: 100%;
}

.tariff_elem {
  display: flex;
  flex-direction: column;
}

.tariff_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 26px;
  height: 98px;
  transition: $transition_medium;
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;
  border-radius: 16px;

  &:not(:first-child) {
    margin-top: 10px;
  }

  &:hover {
    background-color: $color_purple_3;

    .item_benefit span {
      background-color: $color_purple_4;
      color: white;
    }

    .item_title {
      color: white;
    }

    .item_cost {
      color: white;
    }

    .item_check {
      border-color: white;
    }

    .old_cost {
      color: #DDD4FF;
    }

    .cost_dash {
      background-color: #DDD4FF;
    }
  }
}

.tariff_item__active .cost_dash {
  color: #DDD4FF;
}

.tariff_item__active .old_cost {
  color: #DDD4FF;
}

.tariff_item__active .item_benefit span {
  background-color: $color_purple_4;
  color: white;
}

.tariff_item__active {
  background-color: $color_purple_3;

  .item_title {
    color: white;
  }

  .item_cost {
    color: white;
  }

  .item_check {
    border-color: white;

    .item_checked {
      background-color: white;
    }
  }
}

.item_svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.item_benefit {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
}

.item_benefit span {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  height: 24px;
  width: fit-content;
  border-radius: 4px;
  background-color: $color_grey_bg_3;
  color: $color_grey_3;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  transition: $transition_medium;
}

#default-select .item_benefit__text_default span {
  text-transform: initial;
}

.item_title {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  transition: $transition_medium;
}

.cost_block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.old_cost {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: $color_grey_4;
  margin-bottom: 2px;
  transition: $transition_medium;
}

.cost_dash {
  position: absolute;
  left: 0;
  z-index: 1;
  display: flex;
  width: 100%;
  height: 1px;
  background-color: $color_grey_4;
  transition: $transition_medium;
}

.item_cost {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;
  transition: $transition_medium;
}

.item_check {
  width: 20px;
  height: 20px;
  border: 2px solid $color_grey_4;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: $transition_medium;
  margin-left: 16px;

  .item_checked {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    transition: $transition_medium;
    background-color: rgba(255, 255, 255, 0);
  }
}

// блок с промокодом
.sidebar_header {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: $color_cyanite_2;
  text-transform: uppercase;
  margin: 16px 24px 14px 24px;
}

.tariff_slide {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tariff_border {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 2px;
  background-color: $color_purple_bg_1;
}


.special_aspect {
  display: flex;
  flex-direction: row;
  align-items: center;

  &:not(:first-child) {
    margin-top: 15px;
  }
}

.aspect_image {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  border-radius: 50%;
  transition: $transition_medium;
  margin-right: 10px;
}

.aspect_image__green {
  background-color: rgba(137, 206, 84, 0.2);
}

.aspect_image__gray {
  background-color: $color_grey_bg_2;
}

.aspect_svg {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.aspect_text {
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 19px;
  transition: $transition_medium;

  b {
    font-weight: 400;
  }
}

.aspect_text__black {
  color: $color_black;
}

.aspect_text__gray {
  color: $color_grey_2;
}

.promo_input {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  height: 54px;
  padding: 0 20px;
  width: calc(100% - 40px);
  transition: $transition_medium;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: $color_black;
  font-family: $font-Geometria;
  outline: none;

  &:hover {
    border-color: $color_grey_3;
  }

  &:focus {
    border-color: $color_purple_3;
  }
}

.promo_input:disabled:hover {
  border-color: rgba(0, 0, 0, 0.08);
}

.promo_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: default;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  transition: $transition_medium;
  background-color: $color_purple_bg_2;
}

.promo_svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  svg path {
    fill: $color_purple_3;
    stroke: $color_purple_3;
    transition: $transition_medium;
  }
}

.promo_button__active {
  background-color: $color_purple_3;
  cursor: pointer;

  &:hover {
    background-color: $color_purple_2;
  }

  .promo_svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    svg path {
      fill: white;
      stroke: white;
    }
  }
}

.promo_button__applied {
  background-color: $color_green_1;
  cursor: default;

  svg path {
    stroke: white;
    fill: white;
  }
}

.promo_input::placeholder {
  font-family: $font-Geometria;
}

.button__type_remove {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: $color_red_1;
  cursor: pointer;
  position: absolute;
  right: 12px;
  transition: $transition_medium;

  svg {
    width: 10px;
    height: 10px;
  }

  &:hover {
    background-color: #FF6597;
  }
}

@media all and (max-width: 1700px) {
  .tariff_block {
    grid-gap: 20px;
  }

  .tariff_item {
    padding: 0 20px;
    height: 90px;
  }

  .item_svg svg {
    width: 32px;
    height: 32px;
  }

  .item_benefit {
    margin-bottom: 4px;
  }

  .item_benefit span {
    padding: 0 6px;
    height: 21px;
    font-size: 13px;
  }

  .item_title {
    font-size: 17px;
    line-height: 21px;
  }

  .item_cost {
    font-size: 17px;
    line-height: 21px;
  }

  .item_check {
    width: 18px;
    height: 18px;
    margin-left: 12px;
  }

  .item_check .item_checked {
    width: 10px;
    height: 10px;
  }
}

@media all and (max-width: 1600px) {
  .tariff_block {
    margin-top: 28px;
  }

  .sidebar_header {
    font-size: 13px;
    line-height: 17px;
    margin: 16px 22px 12px 22px;
  }

  .block_promo {
    margin: 18px 22px;
  }

  .promo_input {
    height: 50px;
    padding: 0 18px;
    font-size: 15px;
    line-height: 19px;
  }

  .promo_button {
    width: 52px;
    height: 52px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .promo_input {
    height: 50px;
    padding: 0 18px;
    width: calc(100% - 36px);
    font-size: 15px;
    line-height: 19px;
  }

  .promo_button {
    width: 52px;
    height: 52px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .aspect_text {
    font-size: 14px;
    line-height: 18px;
  }

  .aspect_image {
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
  }

  .aspect_svg svg {
    width: 18px;
    height: 18px;
  }
}

@media all and (max-width: 1480px) {
  .tariff_block {
    grid-gap: 18px;
  }
}

@media all and (max-width: 1440px) {
  .tariff_block {
    grid-gap: 18px;
    margin-top: 26px;
  }

  .tariff_item {
    border-radius: 10px;
  }

  .tariff_item:not(:first-child) {
    margin-top: 8px;
  }

  .item_benefit {
    margin-bottom: 4px;
  }

  .item_benefit span {
    padding: 0 5px;
    height: 20px;
    font-size: 12px;
  }

  .item_title {
    font-size: 16px;
    line-height: 20px;
  }

  .item_cost {
    font-size: 16px;
    line-height: 20px;
  }

  .old_cost {
    font-size: 15px;
    line-height: 19px;
    margin-bottom: 2px;
  }

  .item_check {
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 13px;
    line-height: 17px;
    margin: 14px 20px 10px 20px;
  }

  .block_promo {
    grid-gap: 10px;
    margin: 16px 20px;
  }

  .promo_input {
    height: 46px;
    padding: 0 16px;
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .special_aspect:not(:first-child) {
    margin-top: 14px;
  }
}

@media all and (max-width: 1280px) {
  .tariff_block {
    grid-gap: 16px;
    margin-top: 24px;
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 12px;
    line-height: 15px;
    margin: 14px 18px 10px 18px;
  }

  .block_promo {
    margin: 16px 18px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 18px;
    height: 18px;

    svg {
      width: 8px;
      height: 8px;
    }
  }

  .aspect_image {
    width: 26px;
    height: 26px;
    min-width: 26px;
    min-height: 26px;
    margin-right: 8px;
  }

  .aspect_svg svg {
    width: 16px;
    height: 16px;
  }

  .aspect_text {
    font-size: 13px;
    line-height: 16px;
  }

  .special_aspect:not(:first-child) {
    margin-top: 12px;
  }

}

@media all and (max-width: 1160px) {
  #default-select {
    .block_promocode__desktop {
      display: none;
    }

    .block_promocode__tablet {
      display: flex;
    }
  }

  .tariff_item {
    &:hover {
      background-color: rgba(255, 255, 255, 0);

      .item_benefit span {
        background-color: $color_grey_bg_3;
        color: $color_grey_3;
      }

      .item_title {
        color: $color_black;
      }

      .item_cost {
        color: $color_black;
      }

      .item_check {
        border-color: $color_grey_4;
      }

      .old_cost {
        color: $color_black;
      }

      .cost_dash {
        background-color: $color_black;
      }
    }
  }

  .tariff_item__active {
    &:hover {
      background-color: $color_purple_3;

      .item_benefit span {
        background-color: $color_purple_4;
        color: white;
      }

      .item_title {
        color: white;
      }

      .item_cost {
        color: white;
      }

      .item_check {
        border-color: white;
      }

      .old_cost {
        color: #DDD4FF;
      }

      .cost_dash {
        background-color: #DDD4FF;
      }
    }
  }

  // блок с промокодом
  .block_promocode {
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding-top: 40px;
  }

  .block_promocode .sidebar_header {
    text-align: start;
    margin-bottom: 6px;
    text-transform: none;
    font-size: 14px;
    line-height: 18px;
  }

  .sidebar_header {
    text-align: center;
    font-size: 13px;
    line-height: 17px;
    margin: 14px 0 12px 0;
  }

  .block_promo {
    margin: 0;
    grid-gap: 10px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .promo_input {
    height: 46px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 22px;
    height: 22px;

    svg {
      width: 10px;
      height: 10px;
    }
  }
}

@media all and (max-width: 960px) {
  .tariff_item {
    height: 84px;
    border-radius: 8px;
  }

  .item_title {
    font-size: 15px;
    line-height: 19px;
  }

  .item_cost {
    font-size: 15px;
    line-height: 19px;
  }

  .old_cost {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 2px;
  }

  .item_check .item_checked {
    width: 8px;
    height: 8px;
  }

  .block_promocode .sidebar_header {
    text-align: start;
    margin-bottom: 4px;
    text-transform: none;
    font-size: 13px;
    line-height: 17px;
  }

  .sidebar_header {
    font-size: 12px;
    line-height: 15px;
    margin: 12px 0 10px 0;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;
    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 20px;
    height: 20px;

    svg {
      width: 9px;
      height: 9px;
    }
  }
}

@media all and (max-width: 780px) {
  .tariff_block {
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 0.75fr);
  }
}

@media all and (max-width: 720px) {
  .tariff_block {
    grid-gap: 14px;
    margin-top: 20px;
  }

  .tariff_item {
    padding: 0 16px;
  }

  .item_benefit {
    margin-bottom: 3px;
  }

  .item_benefit span {
    padding: 0 5px;
    height: 21px;
    font-size: 12px;
    line-height: 15px;
  }

  .item_title {
    font-size: 14px;
    line-height: 18px;
  }

  .item_cost {
    font-size: 14px;
    line-height: 18px;
  }

  .old_cost {
    font-size: 13px;
    line-height: 17px;
  }
}

@media all and (max-width: 660px) {
  .item_benefit {
    display: none;
  }
}

// mobile
@media all and (max-width: 600px) {
  #default-select {
    .block_promocode__tablet {
      display: none;
    }

    .block_promocode__mobile {
      display: flex;
    }
  }

  .tariff_block {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;
    margin-top: 16px;
  }

  #default-select .block__desktop {
    display: none;
  }

  #default-select .block__mobile {
    overflow: hidden;
    display: block;
  }

  .tariff_item {
    background-color: white;
    width: 100%;
  }

  .tariff_slide {
    width: 280px;
  }

  .tariff_item__active {
    background-color: $color_purple_3;
  }

  .item_svg {
    margin-right: 8px;
  }

  .item_benefit {
    display: flex;
  }

  .item_title {
    font-size: 15px;
    line-height: 19px;
  }

  .item_cost {
    font-size: 15px;
    line-height: 19px;
  }

  .old_cost {
    font-size: 14px;
    line-height: 18px;
  }

  .block_promo {
    margin: 15px 14px;
  }

  .tariff_border {
    display: none;
  }

  .tariff_list {
    padding: 18px 14px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background-color: white;
  }
}

@media all and (max-width: 360px) {
  .tariff_item {
    padding: 0 12px;
  }

  .tariff_slide {
    width: 260px;
  }
}

@media all and (max-width: 340px) {
  .tariff_item {
    height: 76px;
    padding: 0 10px;
  }

  .tariff_item {
    padding: 0 14px;
  }

  .item_svg {
    margin-right: 8px;
  }

  .item_benefit span {
    text-transform: none;
  }

  .item_title {
    font-size: 14px;
    line-height: 18px;
  }

  .item_cost {
    font-size: 14px;
    line-height: 18px;
  }

  .old_cost {
    font-size: 13px;
    line-height: 17px;
  }

  .tariff_slide {
    width: 250px;
  }
}
</style>